import {
  deleteField, doc, getDoc, updateDoc,
} from 'firebase/firestore';
import { auth, db } from './index';

export const fetchWatchList = async () => {
  const user = auth.currentUser;
  if (user) {
    const userRef = doc(db, 'members', user.uid);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      return userDoc.data().watchList || {};
    }
    throw new Error('User document does not exist.');
  } else {
    throw new Error('No user is currently logged in.');
  }
};

export const addVideoToWatchList = async (videoId:string) => {
  const user = auth.currentUser;
  if (user) {
    const userRef = doc(db, 'members', user.uid);
    await updateDoc(userRef, {
      [`watchList.${videoId}`]: {
        id: videoId,
        timestamp: Math.floor(Date.now() / 1000),
      },
    });
  } else {
    throw new Error('No user is currently logged in.');
  }
};

export const removeVideoFromWatchList = async (videoId:string) => {
  const user = auth.currentUser;
  if (user) {
    const userRef = doc(db, 'members', user.uid);
    await updateDoc(userRef, {
      [`watchList.${videoId}`]: deleteField(),
    });
  } else {
    throw new Error('No user is currently logged in.');
  }
};
